export default __webpack_public_path__ + "static/media/drawing.512b9025.jpg";